__turbopack_context__.v({
  "tab": "ProfileTabs-module-scss-module__WKoTRW__tab",
  "tabActive": "ProfileTabs-module-scss-module__WKoTRW__tabActive",
  "tabs": "ProfileTabs-module-scss-module__WKoTRW__tabs",
  "underline": "ProfileTabs-module-scss-module__WKoTRW__underline",
});
